<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-header"><span class="bold">Contents</span></h1>
<h2 class="toc"><a href="#/xhtml/04_Introduction">Introduction</a></h2>
<h2 class="toc1"><a href="#/xhtml/05_Chapter01">Jim Cooksey</a></h2>
<h2 class="toc"><a href="#/xhtml/06_Chapter02">John Cunningham</a></h2>
<h2 class="toc"><span href="#/xhtml/07_Chapter03" title="Link target outside of Sample">Eric Brown</span></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter04" title="Link target outside of Sample">Roland ‘Bee’ Beamont</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter05" title="Link target outside of Sample">Richard ‘Dickie’ Martin</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter06" title="Link target outside of Sample">Duncan Simpson</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter07" title="Link target outside of Sample">Godfrey Auty</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter08" title="Link target outside of Sample">John ‘Jo’ Lancaster</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter09" title="Link target outside of Sample">John Allam</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter10" title="Link target outside of Sample">John Farley</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter11" title="Link target outside of Sample">Peter Twiss</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?baf64f24